export default __webpack_public_path__ + "static/media/plus-sign.eb46fe55.png";